// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3ap3e","signatureButtonsRight":"ModalSign_signatureButtonsRight__3-lfY"};